const popupMapEn = {
  popupMap: {
    label: "New location",
    locationName: "Location name",
    coordinates: "Coordinates",
  },
};
export { popupMapEn };
